import 'core-js/stable';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga';
//import { BrowserRouter } from 'react-router-dom';

import { applyMiddleware, createStore } from 'redux';
import { Provider } from 'react-redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createLogger } from 'redux-logger';
import createSagaMiddleware from 'redux-saga';

import rootReducer, { rootSaga } from 'modules';

// CSS
import 'assets/common/css/font.css';
import 'assets/common/css/reset.css';
import 'assets/common/css/awesome.css';
import 'assets/common/css/swiper.css';
import 'assets/css/dvc.css';

import './index.css';

import App from './App';
import reportWebVitals from './reportWebVitals';

// logger 미들웨어 생성
const logger = createLogger();
const sagaMiddleware = createSagaMiddleware();

// Google Analytics
//const TRACKING_ID=process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID;
const TRACKING_ID='UA-255211922-1';
ReactGA.initialize(TRACKING_ID);

// 스토어 생성
const store = createStore(
  rootReducer,
  // composeWithDevTools(applyMiddleware(logger, sagaMiddleware))
  composeWithDevTools(applyMiddleware(sagaMiddleware)) // logger 사용하지 않을 시
);
sagaMiddleware.run(rootSaga);

ReactDOM.render(
  <React.Suspense fallback={<></>}>
    <Provider store={store}>
      <App />
    </Provider>
  </React.Suspense>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
